function trackPageView(pageName) {
  if (!window.analytics) {
    return
  }

  window.analytics.page(pageName)
}

function identifyUser(user) {
  if (!window.analytics) {
    return
  }

  window.analytics.identify(user.id, {
    email: user.username,
  })
}

function trackAction(actionName, context) {
  if (!window.analytics) {
    return
  }

  window.analytics.track(actionName, context)
}

export default {
  trackPageView,
  identifyUser,
  trackAction,
}
